import React, { useState } from 'react';
import './App.css';
import { 
  CheckCircle,
  Clock,
  Award,
  Users,
  Instagram,
  Facebook,
  Phone,
  Mail,
  MapPin,
  Menu,
  X
} from 'lucide-react';

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };
  const services = [
    {
      icon: (
        <video 
          width="40" 
          height="40" 
          autoPlay 
          loop 
          muted 
          playsInline
          style={{ borderRadius: '50%', objectFit: 'cover' }}
        >
          <source src="/images/echelle-de-piscine.mp4" type="video/mp4" />
        </video>
      ),
      title: "Piscines",
      description: "Construction et entretien de piscines sur mesure pour votre espace extérieur"
    },
    {
      icon: (
        <video 
          width="40" 
          height="40" 
          autoPlay 
          loop 
          muted 
          playsInline
          style={{ borderRadius: '50%', objectFit: 'cover' }}
        >
          <source src="/images/panneau-solaire.mp4" type="video/mp4" />
        </video>
      ),
      title: "Énergie Solaire",
      description: "Installation de panneaux solaires pour une énergie renouvelable et économique"
    },
    {
      icon: (
        <video 
          width="40" 
          height="40" 
          autoPlay 
          loop 
          muted 
          playsInline
          style={{ borderRadius: '50%', objectFit: 'cover' }}
        >
          <source src="/images/ascenseur.mp4" type="video/mp4" />
        </video>
      ),
      title: "Ascenseurs",
      description: "Installation et maintenance d'ascenseurs résidentiels et commerciaux"
    },
    {
      icon: (
        <video 
          width="40" 
          height="40" 
          autoPlay 
          loop 
          muted 
          playsInline
          style={{ borderRadius: '50%', objectFit: 'cover' }}
        >
          <source src="/images/rouleau-de-peinture.mp4" type="video/mp4" />
        </video>
      ),
      title: "Peinture",
      description: "Travaux de peinture intérieure et extérieure de haute qualité"
    },
    {
      icon: (
        <video 
          width="40" 
          height="40" 
          autoPlay 
          loop 
          muted 
          playsInline
          style={{ borderRadius: '50%', objectFit: 'cover' }}
        >
          <source src="/images/pouvoir.mp4" type="video/mp4" />
        </video>
      ),
      title: "Électricité",
      description: "Installations électriques conformes et mises aux normes complètes"
    },
    {
      icon: (
        <video 
          width="40" 
          height="40" 
          autoPlay 
          loop 
          muted 
          playsInline
          style={{ borderRadius: '50%', objectFit: 'cover' }}
        >
          <source src="/images/plomberie.mp4" type="video/mp4" />
        </video>
      ),
      title: "Plomberie",
      description: "Services de plomberie complets pour vos installations sanitaires"
    }
  ];

  const whyChooseFeatures = [
    {
      icon: <Award size={24} />,
      title: "Expertise",
      description: "Plus de 15 ans d'expérience dans le secteur BTP"
    },
    {
      icon: <CheckCircle size={24} />,
      title: "Garantie",
      description: "Tous nos travaux sont garantis 10 ans"
    },
    {
      icon: <Clock size={24} />,
      title: "Réactivité",
      description: "Intervention rapide sous 48h"
    },
    {
      icon: <Users size={24} />,
      title: "Qualification",
      description: "Équipe de professionnels certifiés"
    }
  ];

  const realizations = [
    {
      image: "/images/apres ren.png",
      title: "Piscine Moderne",
      description: "Réalisation d'une piscine à débordement avec système de traitement automatisé"
    },
    {
      image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      title: "Installation Solaire",
      description: "Mise en place de 12 panneaux photovoltaïques pour villa contemporaine"
    },
    {
      image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      title: "Rénovation Complète",
      description: "Rénovation électrique et plomberie pour immeuble résidentiel"
    }
  ];

  return (
    <div className="App">
      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
      )}
      
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <a href="/" className="logo">
              <img src="/images/logo1.png" alt="Atlantic Pool" className="logo-image" />
            </a>
            
            {/* Mobile Menu Toggle */}
            <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>

            {/* Navigation */}
            <nav className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`}>
              <ul>
                <li><a href="#accueil" onClick={closeMobileMenu}>Accueil</a></li>
                <li><a href="#services" onClick={closeMobileMenu}>Nos Services</a></li>
                <li><a href="#realisations" onClick={closeMobileMenu}>Réalisations</a></li>
                <li><a href="#apropos" onClick={closeMobileMenu}>À Propos</a></li>
              </ul>
{/* <a href="/" className="cta-button" onClick={closeMobileMenu}>
                DEMANDER UN DEVIS GRATUIT
              </a> */}
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero" id="accueil">
        <div className="hero-content">
          <h1>L'excellence technique au service de votre habitat</h1>
          <p>
            Spécialistes en piscines, énergie solaire, ascenseurs et tous vos projets BTP. 
            Notre expertise à votre service pour des réalisations de qualité.
          </p>
           <a href="#contact" className="btn-primary">
            Contactez-nous dès maintenant
          </a>
        </div>
      </section>

      {/* Services Section */}
      <section className="section" id="services">
        <div className="container">
          <h2 className="section-title">Nos Services</h2>
          <div className="services-grid">
            {services.map((service, index) => (
              <div className="service-card" key={index}>
                <div className="service-icon">
                  {service.icon}
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="section why-choose" id="apropos">
        <div className="container">
          <h2 className="section-title">Pourquoi Nous Choisir ?</h2>
          <div className="why-choose-content">
            <div className="why-features">
              {whyChooseFeatures.map((feature, index) => (
                <div className="feature-item" key={index}>
                  <div className="feature-icon">
                    {feature.icon}
                  </div>
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Realizations Section */}
      <section className="section" id="realisations">
        <div className="container">
          <h2 className="section-title">Réalisations</h2>
          <div className="realizations-grid">
            {realizations.map((realization, index) => (
              <div className="realization-card" key={index}>
                <img src={realization.image} alt={realization.title} />
                <div className="realization-overlay">
                  <h3>{realization.title}</h3>
                  <p>{realization.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer" id="contact">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Coordonnées</h3>
              <p>
                <Phone size={16} style={{ marginRight: '8px', display: 'inline' }} />
                Téléphone: 06 64 74 44 47
              </p>
              <p>
                <Mail size={16} style={{ marginRight: '8px', display: 'inline' }} />
                Email: atlanticpool1@hotmail.com
              </p>
              <p>
                <MapPin size={16} style={{ marginRight: '8px', display: 'inline' }} />
                Adresse: Grand Casablanca, Maroc
              </p>
            </div>
            <div className="footer-section">
              <h3>Zone Géographique d'Intervention</h3>
              <p>Grand Casablanca et régions limitrophes</p>
              <p>Intervention rapide dans tout le Casablanca-Settat</p>
            </div>
            <div className="footer-section">
              <h3>Suivez-nous</h3>
              <div className="social-links">
                <a href="https://www.instagram.com/atlantic._.pool?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <Instagram size={20} />
                </a>
                <button className="social-button" aria-label="Facebook">
                  <Facebook size={20} />
                </button>
                {/* <a href="#" aria-label="LinkedIn">
                  <Linkedin size={20} />
                </a> */}
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2026 Atlantic Pool. Tous droits réservés.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
